import { Box, styled } from '@mui/material';

export const PhoneNumberWrapperStyled = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  paddingBottom: '1rem',
}) as typeof Box;

export const RemoveWrapperIconStyled = styled('button')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '4rem',
  paddingTop: '4rem',
  background: 'inherit',
}) as typeof Box;

export const ActionsWrapperStyled = styled(Box)({
  marginBottom: 'auto',
  display: 'flex',
  minWidth: '14rem',
  width: '30%',
});
